'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavDrawer", {
    enumerable: true,
    get: function() {
        return NavDrawer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavDrawer = require("./useNavDrawer");
const _renderNavDrawer = require("./renderNavDrawer");
const _useNavDrawerStylesstyles = require("./useNavDrawerStyles.styles");
const _useNavContextValues = require("../useNavContextValues");
const NavDrawer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavDrawer.useNavDrawer_unstable)(props, ref);
    const contextValues = (0, _useNavContextValues.useNavContextValues_unstable)(state);
    (0, _useNavDrawerStylesstyles.useNavDrawerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavDrawerStyles_unstable')(state);
    return (0, _renderNavDrawer.renderNavDrawer_unstable)(state, contextValues);
});
NavDrawer.displayName = 'NavDrawer';
